import React, { createContext, useState, useContext } from "react";

// Criando o contexto
const ProcessingContext = createContext();

// Hook para acessar o contexto
export const useProcessing = () => useContext(ProcessingContext);

// Provider para envolver a aplicação
export const ProcessingProvider = ({ children }) => {
    const [isProcessing, setIsProcessing] = useState(false);

    return (
        <ProcessingContext.Provider value={{ isProcessing, setIsProcessing }}>
            {children}
        </ProcessingContext.Provider>
    );
};
